import { styled, Card } from '@mui/material';

export const StyledCard = styled(Card)({
  padding: '1.5rem',
  marginTop: '2rem',
});
